import { z } from 'zod';
import { FieldTemplateB64Schema } from './field.schema.js';

/**
 * Kiosk face punch. The kiosk captures the same 192-d MobileFaceNet template
 * the field devices use (base64 little-endian float32[192] = 1024 b64 chars)
 * and the server matches it against the encrypted FieldFaceTemplate gallery.
 * The legacy 128-d face-api.js descriptor path has been retired.
 */
export const FacePunchSchema = z.object({
  template: FieldTemplateB64Schema,
  deviceCode: z.string().min(1).max(64),
  photoBase64: z.string().optional().nullable(),
  idempotencyKey: z.string().min(8).max(80).optional(),
  /**
   * Single-use anti-replay nonce from POST /kiosk/face-challenge, fetched
   * immediately before capture. Required by the server for face punches so a
   * replayed template (carrying a stale/consumed nonce) is rejected.
   */
  challenge: z.string().min(8).max(80),
  // ISO capture time recorded when the face punch was made. An OFFLINE punch is
  // replayed hours later, so the server stamps the event from this (clamped)
  // instead of server-receive time — otherwise it lands on the wrong calendar
  // day and corrupts the rollup. Absent for an old queued punch → server now().
  capturedAt: z.string().datetime().optional(),
});
export type FacePunch = z.infer<typeof FacePunchSchema>;

/** Request a fresh face-punch challenge. */
export const FaceChallengeSchema = z.object({
  deviceCode: z.string().min(1).max(64),
});
export type FaceChallenge = z.infer<typeof FaceChallengeSchema>;
